import React, { Component } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';

export class RefundNotification extends Component {

    constructor(props) {
        super(props);
        this.state={
            data: {},
            visible: false
        }
    }

    refund = (data) =>{
        this.setState({
            data: data,
            visible: true
        })
    } 

    actionRefund = () => {
        this.props.accessRefund(this.state.data);
        this.cancelRefund();
    }

    cancelRefund = () =>{
        this.setState({
            data: {},
            visible: false
        })
    }

    render(){
        const footer = (
            <div>
                <Button label="Refund By Credits" onClick={this.actionRefund} />
                <Button label="Refund By Cash" onClick="" />
                <Button label="Cancel" icon="pi-md-close" className="p-button-secondary" onClick={this.cancelRefund} />
            </div>
        );
        return (
            <Dialog header={this.props.header ? this.props.header : ""} footer={footer} visible={this.state.visible} contentStyle={styles.dialogContent} responsive={true} modal={true} dismissableMask={true} showHeader={false} onHide={this.cancelRefund}>
                {this.props.message ? this.props.message : 'Do you really want to delete?'}
            </Dialog>            
        );
    }
}

const styles = {
    dialogContent: {
        maxHeight: '50px',
        minHeight: '50px',
        overflow: 'hidden',
    }
}